export default "__VITE_ASSET__DQ5GhXE1__"